import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';

export interface Props {
  logo: string;
  homeRoute?: string;
  alt: string;
  isSmall?: boolean;
}

function HeaderLogo({ logo, homeRoute = '/', alt, isSmall }: Props) {
  return (
    <Wrapper isSmall={isSmall}>
      <Link to={homeRoute}>
        <HeaderLogoComponent src={logo} alt={alt} title={alt} />
      </Link>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ isSmall?: boolean }>`
  max-width: ${({ isSmall }) => (isSmall ? rem(85) : rem(120))};
  max-height: ${rem(80)};
  margin-right: ${rem(16)};

  ${({ theme }) => theme.mediab.l1150`
    max-width: ${({ isSmall }) => (isSmall ? rem(45) : rem(65))};
    max-height: ${rem(30)};
    margin-right: ${rem(24)};
  `}
`;

const HeaderLogoComponent = styled.img`
  width: 100%;
  height: 100%;
`;

export { HeaderLogo };
